export enum MassiveRequestFlags {
  /** Load the table of request */
  LOAD_REQUEST_TABLE = 1,
  /** Show upload excel page */
  SHOW_UPLOAD_EXCEL_PAGE,
}
